import GradientCanvas         from '@/components/global/GradientCanvas'
import {usePageContext}       from '@/context/PageContext'
import Link                   from 'next/link'
import {useState}             from 'react'
import styles                 from './Z_Logo_Gradient.module.sass'

type Props = {
	ariaLabel?: string,
}

const Z_Logo_Gradient = ({ariaLabel} : Props) => {
	const [hovering, setHovering] = useState(false)

	const {lang} = usePageContext()

	return (<Link
		className={styles.logo_gradient}
		onPointerEnter={() => setHovering(true)}
		onPointerLeave={() => setHovering(false)}
		href={`/${lang}/`}
		data-cursor-pointer
		aria-label={ariaLabel}
	>
		<GradientCanvas
			hovering={hovering}
			className={styles.logo_gradient__canvas}
		/>
	</Link>)
}
export default Z_Logo_Gradient
